exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-icon{max-width:25px;max-height:25px;border:1px solid #ccc;border-radius:100%;padding:10px;text-transform:uppercase;color:#ffffff;margin:2px;font-weight:normal;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}@media only screen and (max-width: 425px){.circle-icon{font-size:10px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/treeTableWithSlider/circleIcon/CircleIcon.style.scss
// module id = 673
// module chunks = 0